import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

import IconButton from '../IconButton';
import Popover from '../Popover';

type WrapperContainerProps = {
  'data-is-open': boolean;
};

export const WrapperContainer = styled('div')<WrapperContainerProps>((props) => ({
  position: 'fixed',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',

  display: props['data-is-open'] ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: '1',
  overflowY: 'auto',

  backgroundColor: 'rgba(0, 0, 0, 0.6)',
}));

export const StyledPopover = styled(Popover)({
  '& .MuiPaper-root': {
    border: '0',
    borderRadius: '2rem',

    '& > div': {
      width: '60rem',

      padding: '4rem',
    },
  },
});

export const Container = styled('div')(({ theme }) => ({
  backgroundColor: theme.colors.base07,
}));

export const TopContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',

  marginBottom: '2.7rem',
});

export const TopLeftContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '1rem',
});

export const BodyContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',

  rowGap: '3rem',

  margin: '3rem 0 4rem',
});

export const BodyItemContainer = styled('div')({
  width: '100%',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',

  rowGap: '1.2rem',
});

export const IconContainer = styled('div')({
  width: '3.2rem',
  height: '3.2rem',

  '& > svg': {
    width: '3.2rem',
    height: '3.2rem',
  },
});

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  '&:hover': {
    '& > svg': {
      '& > path': {
        fill: theme.colors.base03,
      },
    },
  },
}));

export const Base02TextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));

export const ProgressContainer = styled('div')(({ theme }) => ({
  width: '100%',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',

  padding: '2.3rem 2.7rem',

  borderRadius: '1rem',
  backgroundColor: theme.colors.base06,
}));

export const ProgressLeftTextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base01,

  marginLeft: '2rem',
}));

export const FooterContainer = styled('div')({
  marginTop: '3rem',
});

export const StyledCircularProgress = styled(CircularProgress)({
  '&.MuiCircularProgress-root': {
    color: '#497EE4',
  },
});

export const SuccessIconContainer = styled('div')({
  width: '5rem',
  height: '5rem',
  '& > svg': {
    width: '5rem',
    height: '5rem',
  },
});
